
import Component from '../../../assets/scripts/modules/component'

class FigureComponent extends Component {
  init () {
    this.caption = this.element.querySelector('.figure__caption')

    if (this.caption) {
      this.initCaption()
    }
  }

  initCaption () {
    /*
    // Hover
    this.element.addEventListener('mouseenter', () => this.element.classList.add('figure--caption-visible'))
    this.element.addEventListener('mouseleave', () => this.element.classList.remove('figure--caption-visible'))

    // Keyboard focus
    this.caption.tabIndex = '0'
    this.caption.addEventListener('focus', () => this.element.classList.add('figure--caption-visible'))
    this.caption.addEventListener('blur', () => this.element.classList.remove('figure--caption-visible'))

    // Touch
    this.element.addEventListener('touchstart', () => this.element.classList.toggle('figure--caption-visible'))
    */
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.figure').forEach(element => {
  element.instance = element.instance || new FigureComponent(element)
}))
